import { Typography, Box, Grid, Stack, useTheme } from '@mui/material'
import { StatusChip } from 'components/StatusChip/StatusChip'
import { type ContestEntryBonusSchedule, type Sweepstake } from 'src/types/api'
import { convertScheduleHourTo12HourFormat } from 'utils/util'
import { colors } from 'components/ThemeProvider'
import { addMissingDays } from './SweepstakeEntryMultiplierDetailsUtils'

interface EntryMultiplierSectionProps {
  sweepstake: Sweepstake
}

export const EntryMultiplierSection = ({
  sweepstake,
}: EntryMultiplierSectionProps) => {
  const theme = useTheme()

  const daysToDisplay: ContestEntryBonusSchedule[] = addMissingDays(
    sweepstake?.contestEntryBonusSchedules ?? []
  )

  const entryMultiplierEnabled = sweepstake?.contestEntryBonusSchedules?.some(
    (sweepstake) => sweepstake.patronContestEntryBonusMultiplier !== undefined
  )

  return (
    <Box
      sx={{
        border: 1,
        borderColor: theme.palette.grey[300],
        mt: '16px',
        p: '24px',
        width: '100%',
        borderWidth: 1,
        borderRadius: 2,
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          pr: { xs: '0px', sm: '16px' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '16px',
            alignItems: 'center',
            mb: '24px',
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ whiteSpace: 'nowrap' }}
          >
            Entry Multiplier
          </Typography>
          <StatusChip
            active={entryMultiplierEnabled}
            sx={{ maxWidth: '100px' }}
          />
        </Box>
      </Stack>
      <Box>
        {entryMultiplierEnabled ? (
          <Grid container spacing={{ xs: 2, md: 8 }}>
            <Grid item>
              {daysToDisplay?.map((schedule) => {
                return (
                  <Typography
                    key={`${schedule.id}-${schedule.dayName}`}
                    variant="body-1"
                    pb={1}
                  >
                    {`${schedule.dayName}:`}
                  </Typography>
                )
              })}
            </Grid>
            <Grid item>
              {daysToDisplay?.map((schedule) => {
                return (
                  <Typography
                    key={`${schedule.id}-${schedule.dayName}`}
                    variant="body-1"
                    color={
                      schedule.opening &&
                      schedule.closing &&
                      schedule.patronContestEntryBonusMultiplier === 2
                        ? colors.text.primary
                        : colors.text.disabled
                    }
                    pb={1}
                  >
                    {schedule.opening &&
                    schedule.patronContestEntryBonusMultiplier === 2
                      ? `${convertScheduleHourTo12HourFormat(schedule.opening)}`
                      : 'Disabled'}
                    {schedule.closing &&
                    schedule.patronContestEntryBonusMultiplier === 2
                      ? ` - ${convertScheduleHourTo12HourFormat(
                          schedule.closing
                        )}`
                      : ''}
                  </Typography>
                )
              })}
            </Grid>
          </Grid>
        ) : (
          <Typography variant="body1" color={colors.text.secondary}>
            The Entry Multiplier schedule will display here when active.
          </Typography>
        )}
      </Box>
    </Box>
  )
}
